import { useState } from "react";
import {
  Alert,
} from "@mui/material";
import "../styles/register.scss";
// import CheckoutForm from "./CheckOutForm";
import EvergreenForm from "./Form";

export default function Register() {

  //ALERTS
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("");


  return (
    <main className="register">
      <EvergreenForm />
      {showAlert ? <Alert severity={severity}>{message}</Alert> : null}
    </main>
  );
}
